import React from 'react';
import c from 'classnames';
import { Trans } from 'react-i18next';
import { CoreBadgeType } from '../../coreBadge/types';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import TextTooltipOnHover from '../../Popover/TextTooltipOnHover';
import { VisuallyHidden } from '../../a11y';
import { useCustomNotifications } from '../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../Notifications';
import { badgeNotificationsFilter } from '../../SubmissionDetails/helpers';
import s from './CoreBadgeButton.scss';
function getTooltipTranslation(type) {
    switch (type) {
        case CoreBadgeType.DIAMOND:
            return (React.createElement(Trans, { i18nKey: "coreBadge.tooltip.diamond" },
                "Diamond badges are awarded to exceptional deviations and comments.",
                React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments", target: "_blank", rel: "noreferrer" }, "Learn how to award badges"),
                React.createElement(VisuallyHidden, null, "(opens in a new tab)")));
        case CoreBadgeType.EMERALD:
            return (React.createElement(Trans, { i18nKey: "coreBadge.tooltip.emerald" },
                "Emerald badges are awarded to exceptional deviations and comments.",
                React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments", target: "_blank", rel: "noreferrer" }, "Learn how to award badges"),
                React.createElement(VisuallyHidden, null, "(opens in a new tab)")));
        case CoreBadgeType.GLASS:
            return (React.createElement(Trans, { i18nKey: "coreBadge.tooltip.glass" },
                "Quartz badges are awarded to exceptional deviations and comments.",
                React.createElement("a", { href: "https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments", target: "_blank", rel: "noreferrer" }, "Learn how to award badges"),
                React.createElement(VisuallyHidden, null, "(opens in a new tab)")));
        default:
            break;
    }
}
var CoreBadgeButton = function (_a) {
    var type = _a.type, recipient = _a.recipient, badges = _a.badges, className = _a.className, children = _a.children, biData = _a.biData, pushAwardsModal = _a.pushAwardsModal;
    var notifications = useCustomNotifications([NotificationType.Badge]).notifications;
    var hasNotification = notifications.some(badgeNotificationsFilter(type));
    return (React.createElement(TextTooltipOnHover, { tooltipText: getTooltipTranslation(type), tooltipOffset: '0, 2', textClassName: s['tooltip'], isOpen: !hasNotification },
        React.createElement(PlainButtonOrLink, { className: c(s['toggle'], className), onClick: function () {
                return pushAwardsModal({
                    badges: badges,
                    recipient: recipient,
                    defaultActiveType: type,
                });
            } }, children)));
};
CoreBadgeButton.displayName = 'CoreBadgeButton';
export default CoreBadgeButton;
//# sourceMappingURL=CoreBadgeButton.js.map